import config from 'config';

import {
  locatorServiceAPI,
  locatorSSServiceAPI
} from 'shared/services';
import { mappingFeedbackForm } from '../utils';

import {
  AUTH_URL_PATH,
  AUTH_BY_IDENTITY_TOKEN_URL_PATH
} from '../constants';

import {
  AuthToken,
  AuthForm,
  RefreshToken,
  Permissions,
  Identity,
  UserSettings,
  OptionsUpdateSettings,
  FeedbackForm
} from '../types';

export const userAPI = {
  getAuthTokens: (form: AuthForm) => locatorSSServiceAPI.post<AuthToken>(AUTH_URL_PATH, form),
  getAuthTokensByIdentityToken: (identityToken: string, clientId?: string) => locatorSSServiceAPI.post<AuthToken>(
    AUTH_BY_IDENTITY_TOKEN_URL_PATH,
    { client_id: clientId || config.authClientId, identity: identityToken }
  ),
  refreshToken: (refreshToken: string) => locatorSSServiceAPI.post<RefreshToken>('Authorization/Refresh', { token: refreshToken }),
  getAnonymousPermissions: (clientId: string) => locatorSSServiceAPI.get<Permissions>(`UserPermission/Anonymous?clientId=${clientId}`),
  getPermissions: () => locatorSSServiceAPI.get<Permissions>('UserPermission'),
  getIdentity: () => locatorSSServiceAPI.put<Identity>(AUTH_BY_IDENTITY_TOKEN_URL_PATH),
  getSettings: async () => {
    const result = await locatorServiceAPI.get<UserSettings>('user/locator/view/config');
    return { ...result, data: { ...result.data, distanceFromRoute: Number(result.data.distanceFromRoute) / 1000 } };
  },
  updateSettings: (form: OptionsUpdateSettings) => locatorServiceAPI.post('user/locator/view/config', { ...form, distanceFromRoute: Number(form.distanceFromRoute) * 1000 }),
  addFeedback: (form: FeedbackForm) => locatorServiceAPI.post('feedbacks', mappingFeedbackForm(form))
};